import {handleActions} from 'redux-actions';
import {Record} from 'immutable';
import moment from 'moment-timezone';

import * as RevenueReportActions from 'web-app/react/plans/revenue-report/actions';

import * as Actions from './actions';

const DashboardState = Record({
    leaversAndJoinersData: null,
    leaverAndJoinersUpdatedAt: null,
    fetchingLeaversAndJoiners: false,
    enrolledData: null,
    fetchingEnrolledData: false,
    registeredEmployees: null,
    fetchingRegisteredEmployees: false,
    fetchingEmployeeSickDays: false,
    employeeSickDays: null,
    occupancyData: null,
    fetchingOccupancyData: false,
    refreshing: false,
    fetchingRevenueData: false,
    revenueFilter: null,
    year: moment().format('YYYY'),
});

export default handleActions(
    {
        [Actions.fetchLeaversAndJoiners.type]: state => {
            return state.merge({
                leaversAndJoinersData: null,
                fetchingLeaversAndJoiners: true,
            });
        },
        [Actions.fetchLeaversAndJoinersSuccess.type]: (state, {payload}) => {
            return state.merge({
                leaversAndJoinersData: payload.data,
                fetchingLeaversAndJoiners: false,
                leaverAndJoinersUpdatedAt: moment().format('LT, LL'),
            });
        },
        [Actions.fetchLeaversAndJoinersFailed.type]: state => {
            return state.merge({fetchingLeaversAndJoiners: false});
        },
        [Actions.fetchEnrolledData.type]: state => {
            return state.merge({
                enrolledData: null,
                fetchingEnrolledData: true,
            });
        },
        [Actions.fetchEnrolledDataSuccess.type]: (state, {payload}) => {
            return state.merge({
                enrolledData: payload.data,
                fetchingEnrolledData: false,
            });
        },
        [Actions.fetchEnrolledDataFailed.type]: state => {
            return state.merge({fetchingEnrolledData: false});
        },
        [Actions.fetchRegisteredEmployees.type]: state => {
            return state.merge({
                registeredEmployees: null,
                fetchingRegisteredEmployees: true,
            });
        },
        [Actions.fetchRegisteredEmployeesSuccess.type]: (state, {payload}) => {
            return state.merge({
                registeredEmployees: payload.data,
                fetchingRegisteredEmployees: false,
            });
        },
        [Actions.fetchRegisteredEmployeesFailed.type]: state => {
            return state.merge({fetchingRegisteredEmployees: false});
        },
        [Actions.fetchEmployeeSickDays.type]: state => {
            return state.merge({
                employeeSickDays: null,
                fetchingEmployeeSickDays: true,
            });
        },
        [Actions.fetchEmployeeSickDaysSuccess.type]: (state, {payload}) => {
            return state.merge({
                employeeSickDays: payload.data,
                fetchingEmployeeSickDays: false,
            });
        },
        [Actions.fetchEmployeeSickDaysFailed.type]: state => {
            return state.merge({fetchingEmployeeSickDays: false});
        },
        [Actions.fetchOccupancyData.type]: state => {
            return state.merge({
                occupancyData: null,
                fetchingOccupancyData: true,
            });
        },
        [Actions.fetchOccupancyDataSuccess.type]: (state, {payload}) => {
            return state.merge({
                occupancyData: payload.data,
                fetchingOccupancyData: false,
            });
        },
        [Actions.fetchOccupancyDataFailed.type]: state => {
            return state.merge({fetchingOccupancyData: false});
        },
        [Actions.fetchAll.type]: (state, {payload}) =>
            state.merge({
                fetchingLeaversAndJoiners: true,
                fetchingEnrolledData: true,
                fetchingRegisteredEmployees: true,
                fetchingEmployeeSickDays: true,
                fetchingOccupancyData: true,
                fetchingRevenueData: true,
                refreshing: payload.refresh,
                revenueFilter: payload.revenueFilter,
            }),
        [Actions.fetchAllSuccess.type]: state =>
            state.merge({
                refreshing: false,
            }),
        [Actions.fetchAllFailed.type]: state =>
            state.merge({
                refreshing: true,
            }),
        [Actions.setYear.type]: (state, {payload}) =>
            state.merge({
                year: payload.year,
            }),
        [Actions.filterRevenue.type]: (state, {payload}) =>
            state.merge({
                revenueFilter: payload.revenueFilter,
            }),
        [RevenueReportActions.fetchSuccess.type]: state =>
            state.merge({
                fetchingRevenueData: false,
            }),
        [RevenueReportActions.fetchFailed.type]: state =>
            state.merge({
                fetchingRevenueData: false,
            }),
    },
    new DashboardState(),
);
